import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { FaTimes } from "react-icons/fa";

import { cn } from "../utils/kataUtils";

export default function ModalShell({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  maxWidth = "max-w-3xl",
}) {
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return createPortal(
    <div
      className="fixed inset-0 z-[12000] flex items-end justify-center bg-slate-950/70 p-0 backdrop-blur-sm sm:items-center sm:p-5"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) {
          onClose();
        }
      }}
    >
      <section
        role="dialog"
        aria-modal="true"
        aria-label={title}
        className={cn(
          "max-h-[96vh] w-full overflow-hidden rounded-t-[2rem] border border-white/10 bg-white shadow-2xl dark:bg-slate-900 sm:rounded-[2rem]",
          maxWidth
        )}
      >
        <header className="flex items-start justify-between gap-4 border-b border-slate-200 px-5 py-5 dark:border-white/10 sm:px-7">
          <div>
            <h2 className="text-xl font-semibold text-slate-950 dark:text-white sm:text-2xl">
              {title}
            </h2>

            {subtitle ? (
              <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                {subtitle}
              </p>
            ) : null}
          </div>

          <button
            type="button"
            onClick={onClose}
            className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-slate-100 text-slate-600 transition hover:bg-slate-200 hover:text-slate-950 dark:bg-white/10 dark:text-slate-300 dark:hover:bg-white/15 dark:hover:text-white"
            aria-label="Fermer"
          >
            <FaTimes />
          </button>
        </header>

        <div className="max-h-[calc(96vh-90px)] overflow-y-auto">
          {children}
        </div>
      </section>
    </div>,
    document.body
  );
}